/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Acceptance_YearInputs */

const cs_form_acceptance_year = /** @type {(inputs: Form_Acceptance_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rok kolaudace`)
};

const en_form_acceptance_year = /** @type {(inputs: Form_Acceptance_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptance year`)
};

/**
* | output |
* | --- |
* | "Acceptance year" |
*
* @param {Form_Acceptance_YearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_acceptance_year = /** @type {((inputs?: Form_Acceptance_YearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Acceptance_YearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_acceptance_year(inputs)
	return cs_form_acceptance_year(inputs)
});